import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Container, Typography } from '@mui/material';

import { EmptyWorkspace } from 'pages/Workspace/components/EmptyWorkspace/EmptyWorkspace';
import { WorkspaceBusinessPlansMobile } from 'pages/Workspace/components/WorkspaceBusinessPlansMobile';

import { Loader } from 'components/_basic/Loader/Loader';
import LoadingDecorator from 'components/LoadingDecorator';

import { IWorkspaceLayoutProps } from '../types';

import styles from './MobileLayout.module.scss';

const MobileLayoutLoader = () => (
  <Box className={styles.loaderWrapper}>
    <Loader />
  </Box>
);

export const MobileLayout: FC<IWorkspaceLayoutProps> = ({ data, isLoading, error }) => {
  const { t } = useTranslation();

  return (
    <Container className={styles.wrapper}>
      <Typography marginBottom={'24px'} className={styles.title} variant="h1">
        {t('myWorkspace')}
      </Typography>

      <LoadingDecorator data={data} loading={isLoading} error={error} loadingComponent={<MobileLayoutLoader />}>
        {(businessPlans) =>
          businessPlans.total ? <WorkspaceBusinessPlansMobile businessPlan={businessPlans} /> : <EmptyWorkspace />
        }
      </LoadingDecorator>
    </Container>
  );
};
